<template lang="html">
    <entity-page id="page__tracking-status" v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>
        <z-select
            label="Тип статуса" v-validate="'required'"  name="tracking_type" id="tracking_type"
            v-model="status.tracking_type"
            data-vv-as=" " data-vv-name="tracking_type" data-vv-scope="tracking_type"
            v-bind:error="errors.first('tracking_type')"
        >
            <option v-bind:value="1"> Принят у отправителя (влияет на приём) </option>
            <option v-bind:value="2"> Промежуточный (влияет на приём) </option>
            <option v-bind:value="3"> Промежуточный (влияет на выдачу) </option>
            <option v-bind:value="4"> Промежуточный (не влияет на приём и выдачу) </option>
            <option v-bind:value="5"> Прибыл в пункт выдачи (влияет на приём) </option>
            <option v-bind:value="6"> Выдан получателю (влияет на выдачу) </option>
        </z-select>
        <div class="row">
            <z-input
                v-model="status.name" placeholder="Введите название статуса"
                label="Название" name="name" id="name" class="col-6"
                v-validate="'required|min:4|max:255'" v-bind:error="errors.first('name')"
                data-vv-name="name" v-bind:data-vv-as="' '"
            ></z-input>

            <z-input
                v-model="status.description"
                label="Описание" name="description" id="description" class="col-6"
                v-validate="'min:0|max:5000'" v-bind:error="errors.first('description')"
                data-vv-name="description" v-bind:data-vv-as="' '" data-vv-scope="description"
            ></z-input>
        </div>
        <div class="row">
            <z-check
                label="Выставлять статус 'Подтверждена' у заявки при установке статуса"
                id="confirm_deal" v-model="status.confirm_deal" v-bind:value="1" class="col-6"
                v-bind:error="errors.first('confirm_deal')" data-vv-name="confirm_deal" v-bind:data-vv-as="' '"
            ></z-check>
            <div class="col-6">
                <z-color-selector
                    v-model="status.color"  v-bind:colors="colors" label="Выберите цвет"
                    data-vv-name="color"    v-bind:data-vv-as="' '"
                    v-validate="'required'" v-bind:error="errors.first('color')"
                ></z-color-selector>
            </div>
        </div>
    </entity-page>
</template>
<script>
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import ZCheck from '@/components/ZCheck';
    import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZColorSelector from '@/components/ZColorSelector';
    export default {
        components: { ZIconButton, ZInput, ZSelect, ZCheck, EntityPage, ZColorSelector},
        data() {
            return {
                status: {},
                defaultStatus: {
                    id: null,
                    name: null,
                    code: null,
                    description: null,
                    color: null,
                    tracking_type: 1,
                    sort: 100,
                    confirm_deal: 0
                },
                colors: [
                    {label: 'Синий',   value: '#2196f3'},
                    {label: 'Красный', value: '#FF5252'},
                    {label: 'Зеленый', value: '#009688'},
                    {label: 'Черный',  value: '#000000'}
                ]
            }
        },
        created() {
            this.init();
            this.listeners();
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-tracking-status-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
        },
        watch: {
            '$route.params.id'(id) {
                this.init();
            },
        },
        methods: {
            async init() {
                this.$store.commit('openRightPanel');
                this.$store.commit('adaptiveSizePanel');
                if (this.$route.params.id != 'new') await this.getStatus();
                else this.status = Object.assign({}, this.defaultStatus);
            },
            /**
             *Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
            back() {
                this.$router.push({name: 'TrackingStatuses', query: this.$route.query});
            },
            listeners() {
                this.$root.$on('update-traking-status-form', id => {
                    if (parseInt(id) === parseInt(this.$route.params.id)) this.init();
                });
            },
            /**
             * Изменение контрагента
             */
            putStatus() {
                this.$store.commit('showProgressBar', 'load-tracking-status-card');
                this.$store.dispatch('stock/updateTrackingStatus', this.status)
                    .then(() => this.$root.$emit('reload-table', 'tracking-statuses'))
                    .finally(() => this.$store.commit('hideProgressBar', 'load-tracking-status-card'));
            },
            /**
             * Добавление контрагента
             */
            postStatus() {
                this.$store.commit('showProgressBar', 'load-tracking-status-card');
                this.$store.dispatch('stock/addTrackingStatus', this.status).then(r => {
                    if (!r) return;
                    this.$router.replace({name: 'TrackingStatus', params: {id: r.id}})
                    this.$root.$emit('reload-table', 'tracking-statuses')
                }).finally(() => this.$store.commit('hideProgressBar', 'load-tracking-status-card'));
            },
            /**
             * Сохранение контрагента
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return; 
                    if (this.$route.params.id != 'new') this.putStatus();
                    else this.postStatus();
                });
            },
            /**
             * Получение статусов
             */
            getStatus() {
                this.$store.commit('showProgressBar', 'load-tracking-status-card');
                return this.$store.dispatch('stock/getTrackingStatus', this.$route.params.id).then(status => {
                    if(!status) return;
                    else status.confirm_deal  = parseInt(status.confirm_deal);
                         status.tracking_type = parseInt(status.tracking_type);
                         status.type          = parseInt(status.type);
                         this.status = Object.assign({}, status);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-tracking-status-card'));
            },
        }
    }
</script>


// WEBPACK FOOTER //
// TrackingStatus.vue?27674d42